import { useEffect } from "react";

import { IS_IN_IFRAME } from "@src/env";
import { BEARER_TOKEN_KEY } from "@src/features/auth";

import { requestAuthTokenFromParent } from "../messages";

/**
 * Hook to request authentication headers from the parent iframe and store them in localStorage.
 *
 * @param onSuccess - Callback to call when the authentication headers are successfully received.
 */
export function useAuthTokenFromParent(onSuccess: () => void) {
  useEffect(() => {
    if (IS_IN_IFRAME) {
      requestAuthTokenFromParent().then(({ token }) => {
        if (token) {
          localStorage.setItem(BEARER_TOKEN_KEY, token);
          onSuccess();
        }
      });
    }
  }, [onSuccess]);
}
